import HeroCarousel from "./components/HeroCarousel";
import CategoryEntry from "./components/CategoryEntry";
import LatestSection from "./components/LatestSection";
import ShowcaseSection from "./components/ShowcaseSection";
import HotRanking from "./components/HotRanking";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  return (
    <div className="bg-background-100">
      <HeroCarousel />
      <CategoryEntry />
      <LatestSection />
      <ShowcaseSection
        type="movie"
        title="电影精选"
        subtitle="高分口碑电影，值得一看再看"
        icon="ri-film-line"
      />
      <ShowcaseSection
        type="series"
        title="剧集热播"
        subtitle="正在热播与口碑日剧精选"
        icon="ri-tv-2-line"
      />
      <HotRanking />
      <SiteIntro />
    </div>
  );
}